var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Checkbox, ListItem, ListItemIcon, ListItemText, ListSubheader } from '@material-ui/core';
import List from '@material-ui/core/List';
import React from 'react';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { renderDynamicComponent } from '../render';
import { compileUrl, Refresh$ } from '../services/actions';
import { Container } from '../services/di';
import * as objectPath from 'object-path';
import { compilePattern } from '../util';
var DynamicCheckList = /** @class */ (function (_super) {
    __extends(DynamicCheckList, _super);
    function DynamicCheckList(props, ctx) {
        var _this = _super.call(this, props, ctx) || this;
        _this._until = new Subject();
        _this.state = {
            items: [],
            loading: true,
            invalid: false,
            help: null,
            checkedRecords: [],
            groups: null,
            value: []
        };
        return _this;
    }
    DynamicCheckList.prototype.componentDidMount = function () {
        var _this = this;
        this.props.dataState.pathChange
            .pipe(takeUntil(this._until), filter(function (event) { return event.sender != _this && event.path == _this.props.control.path; }))
            .subscribe(function () { return _this.refreshValue(); });
        this.props.dataState.validationReset
            .subscribe(function () { return _this.setState({
            invalid: false,
            help: null
        }); });
        this.props.dataState.validationError
            .pipe(filter(function (event) { return event.path == _this.props.control.path; }))
            .subscribe(function (error) { return _this.setState({
            invalid: true,
            help: JSON.stringify(error.constraints)
        }); });
        this.props.dataState.pathChange
            .pipe(filter(function (change) { return change.path.startsWith(_this.props.control.path) && change.sender != _this; }))
            .subscribe(function () { return _this.refreshItems(); });
        if (this.props.control.endpoint) {
            Refresh$
                .subscribe(function () { return _this.refreshItems(); });
        }
        this.refreshItems();
        this.refreshValue();
    };
    DynamicCheckList.prototype.componentWillUnmount = function () {
        this._until.next();
        this._until.complete();
    };
    DynamicCheckList.prototype.refreshValue = function () {
        var _this = this;
        var targetValue = this.props.dataState.get(this.props.control.path);
        var targetValueAsArray = [];
        if (targetValue) {
            if (Array.isArray(targetValue)) {
                targetValueAsArray = targetValue;
            }
            else {
                targetValueAsArray = [targetValue];
            }
        }
        this.setState({
            checkedRecords: targetValueAsArray
                .map(function (value) {
                // Enum value
                if (typeof value == 'string') {
                    return {
                        label: value,
                        key: value,
                        record: value
                    };
                }
                else {
                    return {
                        label: compilePattern(_this.props.control.labelPattern, value, Container.locale),
                        key: value.id,
                        record: value
                    };
                }
            })
        });
    };
    DynamicCheckList.prototype.refreshGroups = function () {
        var _this = this;
        if (this.props.control.groupBy) {
            var groupItems_1 = {};
            this.state.items
                .forEach(function (item) {
                var groupKey = objectPath.get(item, _this.props.control.groupBy.path);
                var groupLabel = compilePattern(_this.props.control.groupBy.labelPattern, item, Container.locale);
                if (groupItems_1[groupKey] == null) {
                    groupItems_1[groupKey] = {
                        label: groupLabel,
                        items: []
                    };
                }
                groupItems_1[groupKey].items.push(item);
            });
            this.setState({
                groups: Object.values(groupItems_1)
            });
        }
    };
    DynamicCheckList.prototype.refreshItems = function () {
        var _this = this;
        if (this.props.control.endpoint) {
            Container.http.get(compileUrl(this.props.control.endpoint, this.props.dataState))
                .then(function (items) {
                _this.setState({
                    items: items
                });
            }, function (error) {
                alert('Failed');
            });
        }
        else if (this.props.control.items) {
            this.setState({
                items: this.props.control.items
            });
        }
        else if (this.props.control.path) {
            this.setState({
                items: this.props.dataState.get(this.props.control.path)
            });
        }
    };
    DynamicCheckList.prototype.isChecked = function (item) {
        return this.getCheckedState(item) != null;
    };
    DynamicCheckList.prototype.getCheckedState = function (item) {
        var _this = this;
        return this.state.checkedRecords
            .find(function (checkRecord) { return checkRecord.key == objectPath.get(item, _this.props.control.keyPath); });
    };
    DynamicCheckList.prototype.onToggle = function (item) {
        return __awaiter(this, void 0, void 0, function () {
            var checkedRecord, checkedRecords, index;
            return __generator(this, function (_a) {
                checkedRecord = this.getCheckedState(item);
                checkedRecords = this.state.checkedRecords;
                console.log(checkedRecord);
                if (checkedRecord) {
                    index = checkedRecords.indexOf(item);
                    checkedRecords.splice(index, 1);
                }
                else {
                    this.state.checkedRecords.push({
                        key: objectPath.get(item, this.props.control.keyPath),
                        label: compilePattern(this.props.control.labelPattern, item, Container.locale),
                        record: item
                    });
                }
                if (this.props.dataState && this.props.control.path) {
                    this.props.dataState.set(this.props.control.path, checkedRecords, { sender: this });
                }
                this.setState({
                    checkedRecords: checkedRecords
                });
                return [2 /*return*/];
            });
        });
    };
    DynamicCheckList.prototype.render = function () {
        var _this = this;
        var renderItem = function (item, index, dataState) { return React.createElement(ListItem, { button: true, key: index, onClick: function () { return _this.onToggle(item); } },
            React.createElement(ListItemIcon, null,
                React.createElement(Checkbox, { edge: "start", checked: _this.isChecked(item), tabIndex: -1, disableRipple: true })),
            React.createElement(ListItemText, { primary: React.createElement(React.Fragment, null, _this.props.control.children
                    .map(function (child, index) { return renderDynamicComponent(index, child, dataState); })) })); };
        return React.createElement(List, { component: "nav" }, this.state.items
            .map(function (item, index) {
            var dataState = Container.createDataStateService();
            dataState.setRecord(item);
            if (_this.state.groups) {
                return _this.state.groups
                    .map(function (group, index) {
                    return React.createElement(React.Fragment, null,
                        React.createElement(ListSubheader, { key: index }, group.label),
                        group.items
                            .map(function (item, itemIndex) { return renderItem(item, itemIndex, dataState); }));
                });
            }
            else {
                return renderItem(item, index, dataState);
            }
        }));
        // return <div>
        // 	{this.state.items && this.state.items
        // 		.map((item, index) => {
        // 			let dataState = Container.createDataStateService();
        // 			dataState.setRecord(item);
        // 			return <div key={index} onClick={() => this.onClick(item)}>
        // 				{this.props.control.children
        // 					.map((child, index) => renderDynamicComponent(index, child, dataState))}
        // 			</div>;
        // 		})}
        // </div>;
    };
    return DynamicCheckList;
}(React.Component));
export default DynamicCheckList;
//# sourceMappingURL=CheckList.js.map